// Configure what columns are shown here
const columnsByType = {
  'BOGIE': {
    status: true,
    car: true,
    bogie: true,
    asset: true,
    lastDataTimestamp: true
  },
  'DOORS': {
    status: true,
    car: true,
    bogie: false,
    asset: true,
    lastDataTimestamp: true
  },
  'HVAC': {
    status: true,
    car: true,
    bogie: false,
    asset: true,
    lastDataTimestamp: true
  },
};
const hiddenConditions = [];
const reduceWidthWithXCiColumns = 10;
// Header order overrides for condition names.
// Each rule moves matching conditionPattern directly after the first matching anchorPattern.
const conditionSortConfig = {
  placeAfterRules: [
    {
      conditionPattern: /^acceleration rms\b/i,
      anchorPattern: /^v sensor broken\b/i
    }
  ]
};

export {columnsByType, hiddenConditions, reduceWidthWithXCiColumns, conditionSortConfig};